import DataType from '@opsbase/lib-datatype/DataType/DataType';
import i18n from '@opsbase/lib-i18n';
import usePositionCreate from '@opsbase/react-gql-hooks/position/usePositionCreate';
import useNewDataActionsContext from '@opsbase/web-ctrl-newdata/useNewDataActions';
import TeamChooser from '@opsbase/web-data-choosers/TeamChooser';
import CreateDialog from '@opsbase/web-dialogs/CreateDialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import EditableList from '@opsbase/web-editablelist';
import Pane from '@opsbase/web-layout/Pane';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useState } from 'react';
export function PositionCreateDialog() {
    const { name, onCreate } = useParams();
    const [items, setItems] = useState([]);
    const [team, setTeam] = useState(undefined);
    const [singleName, setSingleName] = useState(name);
    const createPosition = usePositionCreate();
    const { raise } = useNotificationActions();
    const { addItemsToType } = useNewDataActionsContext();
    const handleClickCreate = useCallback(() => {
        if (!!singleName) {
            return raise(createPosition({
                patch: {
                    title: singleName,
                    team: { id: team === null || team === void 0 ? void 0 : team.id },
                },
            }).then(newPosition => {
                addItemsToType(DataType.POSITION, [newPosition]);
                onCreate === null || onCreate === void 0 ? void 0 : onCreate(newPosition);
            }), i18n.t('position-created-successful'));
        }
        else {
            return raise(Promise.all(items.map(async (item) => createPosition({
                patch: {
                    title: item.title,
                    team: { id: team === null || team === void 0 ? void 0 : team.id },
                },
            }).then(newPosition => {
                addItemsToType(DataType.POSITION, [newPosition]);
                onCreate === null || onCreate === void 0 ? void 0 : onCreate(newPosition);
            }))), i18n.t('position-created-successful'));
        }
    }, [addItemsToType, createPosition, items, onCreate, raise, singleName, team]);
    const handleChangeTeam = useCallback(newTeam => setTeam(newTeam[0]), []);
    const handleChange = useCallback(newItems => setItems(newItems), []);
    return (React.createElement(CreateDialog, { size: DialogSize.X550_Y350, valid: (!!singleName || items.length > 0) && !!team, onCreate: handleClickCreate, title: i18n.t('create-a-position') },
        !!name && (React.createElement(Pane, { style: { margin: 28 } },
            React.createElement(Text, null, i18n.t('enter-name-of-new-position')),
            React.createElement(TextFieldWithStateAndBlur, { white: true, fullWidth: true, value: singleName, onChange: setSingleName }))),
        React.createElement(Pane, { style: { margin: '0 28px' } },
            React.createElement(Text, null, i18n.t('which-team-this-position-for')),
            React.createElement(TeamChooser, { canCreate: true, required: true, value: team ? [team] : [], onChange: handleChangeTeam })),
        !name && (React.createElement(EditableList, { autoSelectIdx: 0, placeholder: i18n.t('enter-name-of-new-position'), canAddAtBottom: true, canDelete: true, items: items, onChange: handleChange }))));
}
export default PositionCreateDialog;
